import * as React from "react";

import { DefaultWidgetMap } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/configuration/widget-map";
import { ContentBoxProps } from "@com.mgmtp.a12.widgets/widgets-core";

import { getViewHtmlId } from "../modules/focusHandling/sagas";

import { ActivityIdContext } from "./ActivityContext";

export const CustomContentBox: React.ComponentType<ContentBoxProps> = function CustomContentBox(props) {
	const activityId = React.useContext(ActivityIdContext);
	return <DefaultWidgetMap.ContentBox {...props} id={getViewHtmlId(activityId)} />;
};
